import {
  easypostFedexMfaAddressValidationInputSchema,
  easypostFedexMfaAddressValidationOutputSchema,
} from "@redotech/redo-model/carrier-account/easypost-fedex-mfa";

export const easypostFedexMfaAddressValidation = {
  name: "easypostFedexMfaAddressValidation" as const,
  input: easypostFedexMfaAddressValidationInputSchema,
  output: easypostFedexMfaAddressValidationOutputSchema,
};
